import React, {ReactNode} from 'react';
import {Stack, SxProps} from '@mui/material';

type WidgetTitleProps = {
    startIcon?: ReactNode;
    sx?: SxProps;
    children: ReactNode;
};

const WidgetTitle = ({startIcon, sx, children}: WidgetTitleProps) => {
    return (
        <Stack direction="row" alignItems="center" gap={1} sx={sx}>
            {startIcon}
            {children}
        </Stack>
    );
};

export default WidgetTitle;
